import { Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { Kaizens } from '../kaizens/mock-kaizens';
import { ActivateRole, Profile } from '../models/Profile';
import { AspNetAppRoleService } from '../Services/AspNetAppRoleService';

@Component({
    selector: 'app-userprofile',
    templateUrl: './userprofile.component.html',
    styleUrls: ['./userprofile.component.css'],
    standalone: false
})
export class UserprofileComponent implements OnInit {
  public myForm!: UntypedFormGroup;
  public profile!: Profile[];
  activateRole :ActivateRole = new ActivateRole();
  



  constructor(private fb: UntypedFormBuilder, private aspNetAppRole: AspNetAppRoleService, private router: Router) {
    this.myForm = this.fb.group({
      userRole: ['', Validators.required]
    });

  }

  ngOnInit(): void {

    this.aspNetAppRole.getAspNetUserRole(localStorage.getItem('userEmail')!)
      .subscribe(
        data => {
          this.profile = data.data.filter(x => x.name != localStorage.getItem('adrole')!);
        },
        error => {

        }
      )
  }

  onSubmit(form: UntypedFormGroup) {
    
    this.activateRole.userId = localStorage.getItem('userId')!;
    this.activateRole.roleId = form.value.userRole;
    
//console.log(this.activateRole);

    this.aspNetAppRole.setActiveRole(this.activateRole).subscribe(
      data => {
      window.location.href='./';
      }

    );

  }

}
